import axios from "axios";

export const querying = async (tableName: string, item: any) => {
  const headers = {
    "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const data = {
    TableName: tableName,
    Item: item,
  };
  await axios
    .post("https://d222hu8pcowl39.cloudfront.net/default/querying", data, {
      headers,
    })
    .catch((e) => console.log(e));
};